import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { DomService } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { SharedQueryParamKey, UrlUtils } from '@ddt-web/url';

import { FeatureFlagDebugModeComponent } from './components/feature-flag-debug-mode.component';
import { AllAvailableFeatureFlags } from './configs/all-flags.config';
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { FeatureFlagConfig, InternalApplicationStateStoreProxyService } from './feature-flag-config.interface';
import { FeatureFlagLoaderService } from './services/feature-flag-loader.service';

@NgModule({
	declarations: [FeatureFlagDebugModeComponent, FeatureFlagDirective],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		DzButtonModule,
		DzCheckboxModule,
		GenericDirectivesModule
	],
	exports: [FeatureFlagDirective]
})
export class FeatureFlagModule {
	public static forRoot(featureFlagConfig: FeatureFlagConfig): ModuleWithProviders<FeatureFlagModule> {
		return {
			ngModule: FeatureFlagModule,
			providers: [FeatureFlagLoaderService, { provide: InternalApplicationStateStoreProxyService, useValue: featureFlagConfig }]
		};
	}

	constructor(private domService: DomService) {
		const parsedUrl = new URL(window.location.href);
		const showFeatureFlagDebugMode = parsedUrl.searchParams.get(SharedQueryParamKey.FEATURE_FLAG);
		const hasAnyEnableFlag = Object.values(AllAvailableFeatureFlags).some(flag => !!localStorage.getItem(flag));

		// To make sure that even if we import FeatureFlagModule from different modules in the app, the debugger is only shown once
		const featureFlagDebuggerAlreadyPrepended: boolean = document.getElementsByTagName('ac-feature-flag-debug-mode').length > 0;

		if ((hasAnyEnableFlag || showFeatureFlagDebugMode) && !UrlUtils.isProdDmz() && !featureFlagDebuggerAlreadyPrepended) {
			this.domService.prependComponentToBody(FeatureFlagDebugModeComponent);
		}
	}

}

